import { Spin } from 'antd'

const LoadingContent = ({
  message,
  isTransitioning,
}: {
  message?: string
  isTransitioning?: boolean
}) => {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <Spin />
      {message && (
        <p
          className={`text-green text-[#02B1A9] transition-all duration-200 ease-in-out ${
            isTransitioning
              ? 'translate-y-1 transform opacity-0'
              : 'translate-y-0 transform opacity-100'
          }`}
        >
          {message}
        </p>
      )}
    </div>
  )
}

export default LoadingContent
